import React from 'react';
import './AnnouncementBar.scss';

/**
 * Renders announcement bar component
 * @param {String} text
 * @param {String} url
 * @param {String} backgroundColor
 * @param {String} classes
 * @returns {JSX.Element}
 * @constructor
 */
const AnnouncementBar = ({ text, url, classes, domRef, styles }) => (
  <div ref={domRef} className={`c-announcement-bar ${classes}`} style={styles}>
    {
      // Since Shopify doesn't allow "required" fields, we are going to check for
      // an empty string and render the link accordingly
      url === '' ? <p>{text}</p> : <a href={url}>{text}</a>
    }
  </div>
);

export default AnnouncementBar;
